import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';



import { RegisterService } from '../../../api/register/register.service';
import { BloguserService } from 'api/bloguser/bloguser.service';
import { totalmem } from 'os';
import { BlogPostdetailsService } from 'api/blogpostdetails/blogpostdetails.service';
import { BlogpostService } from 'api/blogpost/blogpost.service';
import { Title } from '@angular/platform-browser';
import { ApiConstant } from 'api/api.constant';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './blogverify.html',

})

export class Blogverify implements OnInit {


    blogpreview = []
    url: any
    id: number
    index: number
    blogversionid: number
    title: any
    version: any
    blog = []
    blogg = []
    isactive: boolean
    bid: number

    constructor(private router: Router,

        private blogpostdetailservice: BlogPostdetailsService,
        private blogpostService: BlogpostService, private titleService: Title, private apiconstant: ApiConstant) {
    }

    ngOnInit() {

        this.titleService.setTitle("Blog Verify  | Phoenix Games");
        this.url = this.apiconstant.MainUrl+"blogs/";
       
        this.blogpostService.allBpost().then(data => {
            if (data) {
                this.blogpreview = data.data

            }
        })


    }
    Preview(url, version, id) {




        var finalurl = (this.url + url + '/' + id + '?version=' + version)
        //   // ['/product/' + name1],{queryParams:{'':btoa(id)}}
        // this.finalurl=(this.url+url,{queryParams:{'Version':version}})

      
        window.open(finalurl, "_blank");
        // var finalurl=this.url+url
        // window.open(finalurl, "_blank");

    }


    openDeactive(i, blog) {
        // this.product = blog;
        this.index = i;
        this.isactive = blog.isactive;
        this.bid = blog.blogId;

    }
    DeactiveProduct() {
        var _isactive = 0;
        if (this.isactive == true) {
            _isactive = 0;
        }
        else {
            _isactive = 1;
        }
        var prod = {
            isactive: _isactive
        }
        this.blogpostService.Deactive(prod, this.bid).then(data => {
            if (data) {
                this.blogpreview = data.data

                $(function () {
                    $('#activedeactive').modal('toggle');
                });
            }

        })
    }



    Requestblog(i, blog) {
        this.index = i;
        this.id = blog.blogId
        this.blogversionid = blog.id
    }
    blogaccpeted() {

        var data = {
            status: "LIVE",
            postid: this.blogversionid
        }

        this.blogpostdetailservice.Updatestatus(data, this.id).then(data => {
            
            if(data.status){

                this.blogpreview = data.data


                if (data.blog.status == 'LIVE' && data.blog.version == 1.0) {
                    var blogdata = {
                        blog: data.blog,
                        id: btoa(data.blogId)
                    }
                    this.blogpostService.sendmail(blogdata).then(data => {
    
                    })
                }
                $.notify({
                    message: "Blog Accpeted"
                }, {
                        type: 'success',
                        placement: {
                            from: 'top',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                $(function () {
                    $('#Request').modal('toggle');
                });

            }
            else {

                $.notify({
                    message: "Error"
                }, {
                        type: 'danger',
                        placement: {
                            from: 'top',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });

            }
   

        })

    }
    blogrejected() {

        var data = {
            status: "REJECTED",
            postid: this.blogversionid
        }
        this.blogpostdetailservice.Updatestatus(data, this.id).then(data => {
            if(data.status){
                this.blogpreview = data.data
                // this.ngOnInit()
                $.notify({
                    message: "Blog Rejected"
                }, {
                        type: 'successs',
                        placement: {
                            from: 'top',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                $(function () {
                    $('#Request').modal('toggle');
                });
    


            }
            else{

                $.notify({
                    message: "Blog Rejected"
                }, {
                        type: 'danger',
                        placement: {
                            from: 'top',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                $(function () {
                    $('#Request').modal('toggle');
                });

            }
           


        })
    }

    oldblog(blog) {



        this.title = blog.title
        this.version = blog.version

        var data = {
            title: blog.title,
            version: blog.version
        }




        this.blogpostdetailservice.Oldblog(blog.blogId).then(data => {
            if (data.status) {
                this.blog = data.data
            }



        })
        // this.blogpostdetailservice.oldblog(data).then(data=>{

        // })

    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/blogverify/blogverify.page.ts